module.exports = __webpack_public_path__ + "img/nt107-02-81-1.prt.396e7e78.jpg";